export default __webpack_public_path__ + "static/media/item2.beafb3f3.jpg";